/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFProcess } from './CRSFProcess';
import {
    CRSFProcessFromJSON,
    CRSFProcessFromJSONTyped,
    CRSFProcessToJSON,
} from './CRSFProcess';

/**
 * 
 * @export
 * @interface CRSFProcessPagedResponse
 */
export interface CRSFProcessPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFProcessPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFProcessPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFProcess>}
     * @memberof CRSFProcessPagedResponse
     */
    results?: Array<CRSFProcess>;
    /**
     * 
     * @type {number}
     * @memberof CRSFProcessPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFProcessPagedResponse interface.
 */
export function instanceOfCRSFProcessPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFProcessPagedResponseFromJSON(json: any): CRSFProcessPagedResponse {
    return CRSFProcessPagedResponseFromJSONTyped(json, false);
}

export function CRSFProcessPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFProcessPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFProcessFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFProcessPagedResponseToJSON(value?: CRSFProcessPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFProcessToJSON)),
        'total': value.total,
    };
}

